<div ui-row class="sp-mt-24" [uiGutter]="[0, 24]" [formGroup]="formGroup">
  <ng-container formArrayName="questions">
    <div ui-col [uiXs]="22" class="sp-p-0">
      <ui-form-item class="manage-question-label sp-px-11">
        <ui-form-control>
          <ui-input-group>
            <div>{{ "manage_reflections_question_label" | localize }}</div>
          </ui-input-group>
        </ui-form-control>
      </ui-form-item>
    </div>

    <div ui-col class="sp-p-0" [uiXs]="24" *ngFor="let question of getQuestions.controls; let key = index">
      <div ui-row [formGroupName]="key">
        <div ui-col [uiXs]="22">
          <ui-form-item>
            <ui-form-control>
              <ui-input-group (mouseleave)="onHover(-1)" (mouseenter)="onHover(key)" class="hov-cursor-p" [uiSuffix]="suffixTemplateInfo">
                <div *ngIf="question.value.isDefault">{{ question.value.text }}</div>
                <input
                  *ngIf="!question.value.isDefault"
                  ui-input
                  type="text"
                  formControlName="text"
                  placeholder="Write your question"
                  (keyup.enter)="updateQuestion({ id: question.value.id, text: question.value.text })"
                  (focusout)="updateQuestion({ id: question.value.id, text: question.value.text })" />

                <ng-template #suffixTemplateInfo>
                  <ui-icon
                    (click)="deleteQuestion({ questionId: question.value.id, index: key })"
                    *ngIf="!question.value.isDefault && key === hoveredIndex"
                    uiTheme="outline"
                    uiType="trash-bin"
                    class="fs-16px"></ui-icon>
                </ng-template>
              </ui-input-group>
            </ui-form-control>
          </ui-form-item>
        </div>
        <div ui-col [uiXs]="2">
          <ui-form-control>
            <ui-form-item class="sp-mb-0 justify-cont-c">
              <ui-toggle uiType="toggle-text" formControlName="isEnabled" (ngModelChange)="updateQuestion({ id: question.value.id, isEnabled: question.value.isEnabled })"></ui-toggle>
            </ui-form-item>
          </ui-form-control>
        </div>
      </div>
    </div>
  </ng-container>
</div>
